import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a51715e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "period-controllers"
};
const _hoisted_2 = {
  class: "ltv-type"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "body"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "body"
};
const _hoisted_8 = {
  class: "ltv-offset-button-content"
};
const _hoisted_9 = {
  class: "ltv-offset-text"
};
const _hoisted_10 = {
  class: "selected-number-circle"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ltv-offset-dropdown-lable"
}, "Time periods", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_WrapWithOnlyButton = _resolveComponent("WrapWithOnlyButton");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_b_form_checkbox_group = _resolveComponent("b-form-checkbox-group");
  const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_app_dropdown, {
    class: "current-ltv-dropdown"
  }, {
    "button-content": _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString($options.displayedLTVSelector), 1), _createElementVNode("div", null, [_createVNode(_component_app_icon, {
      icon: "info",
      id: "btn",
      color: "#757575"
    }), _createVNode(_component_app_popover, {
      target: "btn",
      placement: "top",
      customClass: "ltv-tooltip"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString($options.displayedLTVSelector), 1), _createElementVNode("div", _hoisted_4, _toDisplayString($data.ltvOptionTooltips[$options.currentLTV]), 1)]),
      _: 1
    })])])]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.ltvSelectorOptions, option => {
      return _openBlock(), _createElementBlock("div", {
        class: "ltv-type body",
        onClick: $event => _ctx.$emit('update:ltv', option.value)
      }, [_createElementVNode("div", null, _toDisplayString(option.text), 1), _createElementVNode("div", null, [_createVNode(_component_app_icon, {
        icon: "info",
        id: option.value
      }, null, 8, ["id"]), _createVNode(_component_app_popover, {
        target: option.value,
        placement: "top",
        customClass: "ltv-tooltip"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(option.text), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($data.ltvOptionTooltips[option.value]), 1)]),
        _: 2
      }, 1032, ["target"])])], 8, _hoisted_5);
    }), 256))]),
    _: 1
  }), _createVNode(_component_app_dropdown, {
    autoClose: "outside"
  }, {
    "button-content": _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_app_icon, {
      icon: "schedule-icon"
    }), _createElementVNode("div", _hoisted_9, _toDisplayString($options.selectedLTVOffsetLabel), 1), _createElementVNode("div", _hoisted_10, _toDisplayString($options.currentLTVOffset.length), 1)])]),
    body: _withCtx(() => [_createVNode(_component_b_dropdown_form, {
      class: "ltv-offset-dropdown"
    }, {
      default: _withCtx(() => [_hoisted_11, _createVNode(_component_b_form_checkbox_group, {
        modelValue: $options.currentLTVOffset,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.currentLTVOffset = $event),
        class: "ltv-checkbox-group"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.ltvOffsetOptions, option => {
          return _openBlock(), _createBlock(_component_b_form_checkbox, {
            key: option.value,
            value: option.value,
            class: "ltv-checkbox-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_WrapWithOnlyButton, {
              onClick: $event => $options.selectOnly(option),
              showButton: $options.computeShowButton(option),
              onMouseenter: $event => $options.hoveringLTVOffset(option)
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(option.text), 1)]),
              _: 2
            }, 1032, ["onClick", "showButton", "onMouseenter"])]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })]);
}